import { render, staticRenderFns } from "./_base-tree-collapse.vue?vue&type=template&id=7569e772&"
import script from "./_base-tree-collapse.vue?vue&type=script&lang=js&"
export * from "./_base-tree-collapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports